import styled from 'styled-components';
export const StyledBackdrop = styled.div `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;

  background-color: ${(props) => props.theme.colors.ui.primary};
  opacity: ${(props) => (props.open ? 0.7 : 0)};

  transition-timing-function: ${(props) => props.theme.easing};
  transition-duration: ${(props) => `${props.transitionDuration}ms`};
  transition-property: opacity;
`;
//# sourceMappingURL=Overlay.styles.js.map